import type { News } from '@/types';

import React from 'react';

import BoxImage from '../BoxImage';

import {
  Box,
  Button,
  Container,
  Flex,
  Grid,
  Link,
  SectionHeading,
} from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const BlogDesktop: React.FC<{ blogs: News[] }> = ({ blogs }) => {
  const { t } = useTranslation('pages.home');

  return (
    <Container mt="50px" mb="100px">
      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          <SectionHeading title={t('news')} subtitle={t('chooseNews')} />
        </Box>

        <Box>
          <Button
            variant="outline"
            colorScheme="gray"
            as={Link}
            href={routes.blogs.url}
          >
            {t('viewAllBlogs')}
          </Button>
        </Box>
      </Flex>
      <Grid templateColumns="repeat(5, 1fr)" gap="4" my="36px">
        <Box>
          <BoxImage
            title={blogs[0].title}
            image={blogs[0].preview_image}
            alt={blogs[0].alt_image}
            code={blogs[0].code}
          />
          <BoxImage
            title={blogs[1].title}
            image={blogs[1].preview_image}
            alt={blogs[1].alt_image}
            style={{ marginTop: '10px' }}
            code={blogs[1].code}
          />
        </Box>
        <Box alignSelf={'center'} mt="50px">
          <BoxImage
            title={blogs[2].title}
            image={blogs[2].preview_image}
            alt={blogs[2].alt_image}
            code={blogs[2].code}
          />
        </Box>
        <Box>
          <BoxImage
            title={blogs[3].title}
            image={blogs[3].preview_image}
            alt={blogs[3].alt_image}
            code={blogs[3].code}
          />
        </Box>
        <Box>
          <BoxImage
            title={blogs[4].title}
            image={blogs[4].preview_image}
            alt={blogs[4].alt_image}
            code={blogs[4].code}
          />
          <BoxImage
            title={blogs[5].title}
            image={blogs[5].preview_image}
            alt={blogs[5].alt_image}
            code={blogs[5].code}
            style={{ marginTop: '10px' }}
          />
        </Box>
        <Box alignSelf={'center'} mt="50px">
          <BoxImage
            title={blogs[6].title}
            image={blogs[6].preview_image}
            alt={blogs[6].alt_image}
            code={blogs[6].code}
          />
        </Box>
      </Grid>
    </Container>
  );
};
export default BlogDesktop;
